import { hideCardForTime } from './hideCardForTime';

export const getSubCardsForTime = (sub: any) => {
    const subs2 = JSON.parse(JSON.stringify(sub || []));
    const ret = [];
    for (let i = 0; i < subs2.length; i++) {
        const item1 = subs2[i];
        const flag = hideCardForTime(item1?.timeStart, item1?.timeEnd);
        if (!flag) {
            ret.push(item1);
        }
    }
    return ret;
};
